import { Component } from '@angular/core';
import { ModalService } from '@lsq-frontend/common-ui';

export interface AdminManageBuyerInformationChanges {
    label: string;
    oldData: string | number;
    newData: string | number;
}

export interface AdminManageBuyerInformationChangesSection {
    sectionLabel: string;
    sectionChanges: AdminManageBuyerInformationChanges[];
}

@Component({
    selector: 'admin-manage-buyer-confirm-changes-modal',
    styleUrls: ['./confirm-changes-modal.component.scss'],
    template: `
        <div>
            <p class="body" [style.marginBottom]="'2rem'">
                Shown below is the previous and updated information, please click the Confirm button
                to accept and save these changes.
            </p>

            <div class="row">
                <div class="col-6 border-right">
                    <p class="label" [style.marginTop]="'1rem'">Previous Information</p>
                </div>
                <div class="col-6 border-right">
                    <p class="label" [style.marginTop]="'1rem'">Updated Information</p>
                </div>

                <ng-container *ngFor="let change of changes">
                    <div
                        class="col-6 border-right"
                        [style.paddingTop]="'2rem'"
                        [id]="change.label.split(' ').join('') + 'Old'"
                    >
                        <p class="data-label">{{ change.label }}</p>
                        <p class="body">{{ change.oldData || '—' }}</p>
                    </div>
                    <div
                        class="col-6"
                        [style.paddingTop]="'2rem'"
                        [id]="change.label.split(' ').join('') + 'New'"
                    >
                        <p class="data-label">{{ change.label }}</p>
                        <p class="body">{{ change.newData || '—' }}</p>
                    </div>
                </ng-container>
            </div>
        </div>
    `
})
export class AdminManageBuyerConfirmChangesModalComponent {
    public changes: AdminManageBuyerInformationChanges[];
    public changesBySection: AdminManageBuyerInformationChangesSection[];

    constructor(private _modalService: ModalService) {
        this.changes = this._modalService.modal.data.changes;
        this.changesBySection = this._modalService.modal.data.changesBySection;
    }
}
